<autoCompleteBox #autoCompleteBoxComp [className]="'autoCompleteBoxContain'" [style.left.px]="popupPositionLeft"
    [style.top.px]="popupPositionTop" [style.display]="showAutoCompleteBox">
</autoCompleteBox>

<table class="table table-striped ">
    <thead>
        <th scope="col">{{'Label' | i18n}}</th>
        <th scope="col">{{'Value' | i18n}}</th>
        <th scope="col" class="hide-on-mobile">{{'Score' | i18n}}</th>
    </thead>
    <tbody>
        <tr scope="row" *ngFor="let item of tableData; let i = index" (mouseover)="receiptItemOver(item)"
            [class.trChosen]="item.chosen == true">


            <td><input type="text" [(ngModel)]="item.label.word.text" [size]="item.label.word.text.length"
                    class="editable" (click)="tableItemDown($event, 'value', item)" (focusout)="itemFocusout()"></td>

            <td class="valueColumn"><input type="text" [(ngModel)]="item.value.word.text" class="editable"
                    (click)="tableItemDown($event, 'value', item)" (focusout)="itemFocusout()"
                    [style.color]="item.color"></td>

            <td class="hide-on-mobile"> % {{printScore(item)}}</td>
        </tr>
    </tbody>
    <div (click)="downloadImg()">
        {{uid}}
    </div>
    <div>
        <tag-data [tableData]="tableData" [uid]="uid"></tag-data>
    </div>
</table>